<template><span @click=nav class="d-inline-block z-component zoezi-menuitem" style="color: rgb(248, 217, 185);">{{label}}</span></template>
<script>export default {
    props: {
        label: {
            title: 'Knapptext',
            type: String,
            default: 'Klicka här'
        },
        url: {
            title: 'URL',
            type: String,
            default: 'https://motionhealthclub.se'
        }
    },
    methods: {
        nav() {
            window.open(this.url);
        }
    },
    mounted() {
        const grandElement = this.$parent.$parent;
        console.log(grandElement)
        grandElement.$listeners.click = this.nav
        grandElement.click = this.nav
        grandElement.$attrs.onClick = this.nav
    },
}</script>